<template>
	<div class="product-edit">
		<!-- <div class="common-btn-area">
			<span class="btn" @click="$router.go(-1)"><i class="fas fa-undo"></i> 戻る</span>
		</div> -->
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<ProductForm
				:product="product"
				:name.sync="product.name"
				:product_code.sync="product.product_code"
				:cost_price.sync="product.cost_price"
				:standard_price.sync="product.standard_price"
				:list_price.sync="product.list_price"
				:specification.sync="product.specification"
				:wildcard.sync="product.wildcard"
				:product_category_id.sync="product.product_category_id"
				:product_sub_category_id.sync="product.product_sub_category_id"
			>
			</ProductForm>
			<v-row no-gutters class="mt-4" justify="center">
				<ConfirmationUpdateDialog :statuses="statuses" :product="product" :id="id" />
			</v-row>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import ProductForm from "./ProductForm.vue"
import ConfirmationUpdateDialog from "./components/ConfirmationUpdateDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		ProductForm,
		ConfirmationUpdateDialog,
	},
	data() {
		return {
			mainTitle: "製品",
			title: "コピーして新規作成",
			id: this.$route.params.id,
			product: {
				name: "",
				product_code: "",
				cost_price: "",
				standard_price: "",
				list_price: "",
				specification: "",
				wildcard: true,
				categories: [],
				product_category_id: "",
				product_sub_category_id: "",
				product_code_prefixes: [],
				product_code_prefix_id: "",
				persistent_hint: false,
			},
			statuses: [],
			openConfirmationFlag: false,
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchProduct()
	},
	methods: {
		openConfirmationDialog() {
			this.openConfirmationFlag = true
		},
		fetchProduct() {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/products/${this.id}/edit`, { headers })
				.then((res) => {
					this.product = res.data.product
					const product_code_num = res.data.product.product_code.match(/\d{1,}/)
					this.product.product_code = product_code_num
					this.product.categories = res.data.categories
					this.product.product_code_prefixes = res.data.prefixes
					this.statuses = res.data.statuses
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					if (err.response.status == 403) {
						this.$router.push({ name: err.response.data.route })
					}
				})
		},

		isPresence(value) {
			return value !== null && value !== ""
		},
	},
	computed: {
		isValid() {
			if (
				this.isPresence(this.product.name) &&
				this.isPresence(this.product.product_category_id) &&
				this.isPresence(this.product.product_sub_category_id) &&
				this.isPresence(this.product.product_code_prefix_id) &&
				this.isPresence(this.product.product_code)
			) {
				return true
			} else {
				return false
			}
		},
	},
}
</script>
